import type { ChangeEvent, FC, InputHTMLAttributes } from "react";

import { ErrorMessage } from "../ErrorMessage";

import * as styles from "./Input.styles";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label?: string;
  error?: string | undefined;
  errorMessages: Record<string, string>;
  onChange: (name: string | undefined, value: string) => void;
}

const Input: FC<Props> = props => {
  const {
    label,
    type = "text",
    name,
    id,
    value,
    onChange,
    placeholder,
    error,
    errorMessages = {},
    ...rest
  } = props;

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    onChange?.(name, target.value);
  };

  return (
    <div css={styles.input}>
      <label htmlFor={id}>
        {label}
        <ErrorMessage
          error={error || name}
          errorMessages={errorMessages}
          prefix={label ? " - " : ""}
        />
      </label>
      <input
        css={styles.inputField}
        aria-label={label}
        onChange={handleChange}
        {...{ type, name, id, value, placeholder, ...rest }}
      />
    </div>
  );
};

export { Input };
export type { Props as InputProps };
